import React from "react";

function BlogNewsletter() {
  return (
    <div className="widget sidebar-newsletter">
      <div className="sn-icon">
        <img src="img/icon/sn_icon.png" alt="" />
      </div>
      <div className="sn-title">
        <h4 className="title">Subscribirse a Newsletter</h4>
      </div>
      <form className="sn-form">
        <input type="text" placeholder="Ingresa tu Email" />
        <button className="btn">Subscribirse</button>
      </form>
    </div>
  );
}

export default BlogNewsletter;
